<template>
<div>
  <div style="width: calc(100vw - 450px);">
    <el-descriptions :column="2" border size="mini" :label-style="{width: '100px'}">
      <el-descriptions-item label="仪表类型">
        <el-select size="mini" style="width: 100%" v-model="where.meter_type" filterable placeholder="类型" class="kuan">
          <el-option
            v-for="item in meter_type_list"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="当前房产">
        <el-input size="mini" placeholder="请选择房产" v-model="where.house_name" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="仪表编号">
        <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="收费标准">
        <el-select size="mini" style="width: 100%" v-model="where.charging_standard" filterable placeholder="收费标准" class="kuan">
          <el-option
            v-for="item in house_charge_list"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="仪表状态">
        <el-checkbox-group v-model="where.status_ids">
          <el-checkbox v-for="item in [{name:'在用',val:1},{name:'停用',val:2}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-descriptions-item>
      <el-descriptions-item label="仪表性质">
        <el-checkbox-group v-model="where.meter_nature_ids">
          <el-checkbox v-for="item in meter_nature_list" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-descriptions-item>
      <el-descriptions-item label="仪表名称">
        <el-input size="mini" placeholder="请输入收费对象" v-model="where.name" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="能耗类型">
        <el-checkbox-group v-model="where.energy_ids">
          <el-checkbox v-for="(item,index) in energy_list" :disabled="!isEnergyAble(item.val)" :label="item.val" :key="index">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-descriptions-item>
      <el-descriptions-item label="下载操作">
        <el-button size="mini" type="primary" @click="dowExcel()" style="margin-right: 5px;">下载模板</el-button>
      </el-descriptions-item>
      <el-descriptions-item label="上传操作">
        <el-button size="mini" type="primary" @click="uploadExcel()" style="margin-right: 5px;">上传模板</el-button>

        <el-button size="mini" v-if="excel_list&&excel_list.length&&(excel_list_repeated_num===0)&&(excel_list_is_project_num===0)" type="primary" @click="importExcel">导入</el-button>
        <el-button size="mini" v-if="excel_list&&excel_list.length&&(excel_list_repeated_num===0)&&(excel_list_is_project_num===0)" type="primary" @click="meterImportExcelCache">发起审批</el-button>
        <el-button size="mini" v-if="excel_list&&excel_list.length" type="warning" @click="cleanImportExcel">取消</el-button>

      </el-descriptions-item>
    </el-descriptions>
  </div>

  <el-tabs v-model="activeIndex">
    <el-tab-pane label="仪表列表" name="list">
      <div style="display: flex;flex-direction: row;">
        <div>
          <el-link @click="table_where_name=''">总条数： <span style="color: #038dce">{{excel_list_num}}</span> 条</el-link>
        </div>
        <div style="margin-left: 50px">
          插入： <span style="color: #ff3d00">{{excel_list_insert_num}}</span> 条
        </div>
        <div style="margin-left: 50px">
          修改： <span style="color: #ff3d00">{{excel_list_num-excel_list_insert_num}}</span> 条
        </div>
        <div style="margin-left: 50px">
          <el-link @click="table_where_name='is_repeated'">编号重复： <span style="color: #ff3d00">{{excel_list_repeated_num}}</span> 条(红底)</el-link>
        </div>
        <div style="margin-left: 50px" >
          <el-link @click="table_where_name='is_project'">房产错误： <span style="color: #ff3d00">{{excel_list_is_project_num}}</span> 条(黄底)</el-link>
        </div>
        <div style="margin-left: 50px" >
          <el-link @click="table_where_name='is_not_architecture'">上下级异常： <span style="color: #ff3d00">{{excel_list_not_architecture_num}}</span> 条(紫底)</el-link>
        </div>
      </div>
      <div class="table-wrap">
        <el-table class="table-wrap2" border v-loading="loading" :data="pageData.list" height="calc( 100vh - 500px )" @selection-change="handleSelectionChange" :row-class-name="tableRowClassName">
          <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template slot-scope="scope">
              <span :style="{color:(scope.row.id?'#038dce':'#2fb902')}">{{scope.row.id?'修改':'新增'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="msg" label="异常信息警告" align="center" width="200">
            <template slot-scope="scope">
              <span style="color:#ff0000;">{{scope.row.msg}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="meter_type_name" label="仪表类型" align="center" width="120"></el-table-column>
          <el-table-column prop="number" label="仪表编号" align="center" width="100"></el-table-column>
          <el-table-column prop="name" label="仪表名称" align="center" width="180"></el-table-column>
          <el-table-column prop="meter_nature_name" label="仪表性质" align="center" width="120"></el-table-column>
          <el-table-column prop="meter_energy_name" label="能耗类型" align="center" width="120"></el-table-column>
          <el-table-column prop="charging_standard_name" label="收费标准" align="center" width="180"></el-table-column>
          <el-table-column prop="house_name" label="所在房产" align="center" width="320"></el-table-column>
          <el-table-column prop="magnification" label="倍率" align="center" width="80"></el-table-column>
          <el-table-column prop="start_number" label="初始读数" align="center" width="120"></el-table-column>
          <el-table-column prop="meter_level" label="仪表等级" align="center" width="80"></el-table-column>
          <el-table-column prop="parent_number" label="上级仪表编号" align="center" width="120"></el-table-column>
          <el-table-column prop="position" label="位置" align="center" width="100"></el-table-column>
          <el-table-column prop="install_time" label="安装日期" align="center" width="200"></el-table-column>
          <el-table-column prop="remarks" label="备注" align="center" width="100"></el-table-column>
          <el-table-column prop="id" label="主表编号" align="center" width="100"></el-table-column>
        </el-table>
        <div style="margin-top: 20px;text-align: right;margin-right: 20px;">
          <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
        </div>
      </div>
    </el-tab-pane>
    <el-tab-pane label="线路架构图" name="diagram">
      <div style="height: calc( 100vh - 500px )">
        <MeterNumberDiagram v-if="activeIndex==='diagram'" :excel_list="excel_list" :height="diagram_height" :width="diagram_width"/>
      </div>
    </el-tab-pane>
  </el-tabs>

</div>
</template>

<script>
import UploadFileSysc from "../../../App/Card/components/UploadFileSysc";
import Http from "../../common/Http";
import MeterNumberDiagram from "./components/MeterNumberDiagram";
import CommonMixin from "../../common/CommonMixin";
import MeterHttp from "../../common/MeterHttp";
export default {
  name: "MeterImport",
  components: {MeterNumberDiagram, UploadFileSysc},
  mixins:[CommonMixin],
  inject:['mainObj','componentId','setComponentId'],
  data () {
    return {
      diagram_height:window.innerHeight-500,
      diagram_width:(window.innerWidth*0.95-40),
      host_url:"",
      loading: false,
      activeName:"meter_export",
      where:{
        meter_type: "",
        house_name: "",
        project_id:"",
        number: "",
        charging_standard: "",
        status: "",
        status_ids: [1],
        line: "",
        meter_nature: "",
        meter_nature_ids: [1,2,3,4],
        energy_ids:this.getDefaultEnergyIds(),
        name: "",
        meter_virtually:[1]
      },
      excel_list:[],
      dialogVisible:false,
      form:{
        name:"",
        xsc_code:"",
        status:"",
        invoicing_limit:"",
        refund_audit:"",
        sort:"",
        expense_category:"",
        bill_type:"",
        files:"",
        financial_code:"",
        financial_code_name:"",
        remarks:"",
      },
      house_charge_list:[],
      house_charge_item_list:[],
      excel_file:"",
      meter_type_list: [],
      chargeItem_name_id:"",
      meter_nature_list:[{name:'分表',val:1},{name:'总表',val:2},{name:'分摊表',val:3},{name:'电力负荷表',val:4}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      table_where_name:"",
      pageData:{
        list:[],
        total: 0,
        pageSize: 15,
        page: 1
      },
      activeIndex:"list"
    }
  },
  mounted() {
    this.host_url=__HTTP__.defaults.baseURL;
    this.where.project_id = this.mainObj.project_id;
    this.getMeterTypeList()
    this.where.house_name=this.mainObj.house_name;
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },
    "where.project_id":function (n) {
      this.getHouseChargeList();
    },
    "where.meter_type":function (n) {
      this.chargeItem_name_id=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_id||"";
      this.getHouseChargeList();
    },
    table_where_name(n,o){
      this.pageChange(1)
    },
    "mainObj.house_name":function (n) {
      const that=this;
      that.where.project_id = that.mainObj.project_id;
      that.where.house_name=that.mainObj.house_name;
    }
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    },
    excel_list_num(){
      return this.excel_list.length
    },
    excel_list_insert_num(){
      return this.excel_list.filter(ret=>{
        return !(ret.id>0)
      }).length
    },
    excel_list_repeated_num(){
      return this.excel_list.filter(ret=>{
        return !!ret.is_repeated
      }).length
    },
    excel_list_is_project_num(){
      return this.excel_list.filter(ret=>{
        return !!ret.is_project
      }).length
    },
    excel_list_not_architecture_num(){
      return this.excel_list.filter(ret=>{
        if(ret.meter_energy_name==='分摊能耗'&&ret.meter_nature_name!=='总表'&&!ret.parent_number){
          return true
        }else if(ret.meter_energy_name==='分摊能耗'&&ret.meter_nature_name==='总表'&&ret.parent_number){
          return true
        }else {
          return false
        }
      }).length
    },
  },
  methods: {
    showExcel(excel_file) {
      const that = this;
      that.loading=true;
      if(!excel_file){
        this.$message.error('请提交Excel表单');
        return false;
      }
      MeterHttp.post("Meter/meterImportExcelShow?user_type="+(that.$route.query.type||0),{
        project_id: that.mainObj.project_id,
        file: excel_file,
      }, res => {
        that.loading=false;
        if(res.code) {
          that.excel_list=res.data.map(ret=>{
            if(ret.meter_energy_name==='分摊能耗'&&ret.meter_nature_name!=='总表'&&!ret.parent_number){
              ret.msg="分摊能耗非总表必要有上级，请设置上级！";
              ret.is_not_architecture=1;
            }else if(ret.meter_energy_name==='分摊能耗'&&ret.meter_nature_name==='总表'&&ret.parent_number){
              ret.msg="分摊能耗总表无上级，请核实！"
              ret.is_not_architecture=1;
            }
            return ret;
          })
          that.pageData.total=that.excel_list.length
          that.excel_file=excel_file;
          that.pageChange(1)
        }else {
          that.$message.error(res.msg||"表格解析异常");
        }
      })
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i
      let list=reObject(that.excel_list)
      if(that.table_where_name){
        list=reObject(that.excel_list.filter(ret=>!!ret[that.table_where_name]))
      }
      that.pageData.list=list.splice((that.pageData.page-1)*that.pageData.pageSize,that.pageData.pageSize);
    },
    importExcel() {
      const that = this;
      if(!that.excel_file){
        this.$message.error('请提交Excel表单');
        return false;
      }
      if(!that.excel_list||!that.excel_list.length){
        this.$message.error('Excel表单无数据');
        return false;
      }

      that.$confirm('您确定导入Excel表单数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.loading=true;
        MeterHttp.post("Meter/meterImportExcel?user_type="+(that.$route.query.type||0),{
          project_id: that.mainObj.project_id,
          file: that.excel_file,
        }, res => {
            if(res.code) {
              that.$message.success('Excel表单导入成功');
              that.excel_list=[];
              that.excel_file=""
            }else {
              that.$message.error('Excel表单导入失败');
            }
            that.loading=false;
        });
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消导入'
        });
      });

    },
    meterImportExcelCache() {
      const that = this;
      if(!that.excel_file){
        this.$message.error('请提交Excel表单');
        return false;
      }
      if(!that.excel_list||!that.excel_list.length){
        this.$message.error('Excel表单无数据');
        return false;
      }

      that.$confirm('您确定Excel表单数据完整性吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.loading=true;
        MeterHttp.post("Meter/meterImportExcelCache?user_type="+(that.$route.query.type||0),{
          project_id: that.mainObj.project_id,
          file: that.excel_file,
        },res=>{
          if(res.code) {
            // that.$message.success('Excel表单导入成功');
            let timeValue=(new Date()).getTime()
            that.excel_list=[];
            that.excel_file="";
            if(that.$route.query.type>0){
              that.$route.query.type==1&&ERP.navigateTo("/flow/FlowView?sheet_id=44&master_id=42&batch_number="+res.data+'&timeValue='+timeValue);
              that.$route.query.type==2&&ERP.navigateTo("/flow/FlowView?sheet_id=42&master_id=40&batch_number="+res.data+'&timeValue='+timeValue);
            }else {
              that.$confirm('选择公摊仪表/业主仪表', '提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '公摊仪表',
                cancelButtonText: '业主仪表',
                type: 'warning',
                center: true
              }).then(() => {
                ERP.navigateTo("/flow/FlowView?sheet_id=42&master_id=40&batch_number="+res.data+'&timeValue='+timeValue)
              }).catch(() => {
                ERP.navigateTo("/flow/FlowView?sheet_id=44&master_id=42&batch_number="+res.data+'&timeValue='+timeValue)
              });
            }
          }else {
            that.$message.error('Excel表单导入待审缓存失败');
          }
          that.loading=false;
        });

      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消导入'
        });
      });

    },
    cleanImportExcel(){
      this.excel_file=""
      this.pageData.list=[];
      this.pageData.page=1;
      this.pageData.pageSize=15;
      this.excel_list=[]
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    nodeClick(data){
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      this.where.project_id = data.tree[0].pindex_id;
      this.where.house_name=tree_str;
    },
    getMeterTypeList(){
      var that=this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id: that.mainObj.project_id,
        where: JSON.stringify(where),
        field: "id,name,expenditure_id,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    getHouseChargeList(){
      var that=this;
      let where={};
      this.where.project_id&&(where.pindex_id=this.where.project_id);
      this.chargeItem_name_id&&(where.chargeItem_name_id=this.chargeItem_name_id);
      MeterHttp.get("HouseCharge/getList",{
        project_id: that.mainObj.project_id,
        where: JSON.stringify(where),
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      })
    },
    dowExcel(){
      if(this.where.house_name == ''){
        this.$Message.error('点击左边树选择项目!');
        return false;
      }
      var that=this;
      let where=reObject(that.where);
      ERP.showLoading()
      MeterHttp.get("Meter/MeterExportExcel",{
        project_id: that.mainObj.project_id,
        where: JSON.stringify(where),
        user_type: (that.$route.query.type || 0),
      },ret=>{
        ERP.hideLoading()
        if(ret.code){
          if(ret.data.indexOf("http")===-1){
            window.open(__HTTP__.defaults.baseURL +ret.data)
          }else {
            window.open(ret.data)
          }
        }
      })
    },
    tableRowClassName({row, rowIndex}) {
      const that=this;
      if (row.is_repeated) {
        return 'warning-row';
      }else if (row.is_project) {
        return 'project-row';
      }else if (row.is_not_architecture) {
        return 'architecture-row';
      }else {
        return "success-row"
      }
    },
    navBack(){
      ERP.navigateBack()
    },
    uploadExcel(){
      const that=this;
      MeterHttp.uploadFile(file=>{
        that.showExcel(file)
      })
    }
  }
}
function reObject(item){
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>
@import "../../common";
.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 450px );
  //overflow-x: scroll;
}
.table-wrap2{
  >>>.warning-row{
    background-color: rgba(255, 61, 0, 0.19);
    color: #343436;

    &:hover{
      color: #000000;
    }
  }
  >>>.project-row{
    background-color: rgba(255, 174, 0, 0.19);
    color: #343436;

    &:hover{
      color: #000000;
    }
  }
  >>>.architecture-row{
    background-color: rgba(156, 74, 169, 0.34);
    color: #343436;

    &:hover{
      color: #000000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/MeterImport.vue